module.exports = __webpack_public_path__ + "media/images/icons/bi-star-fill-2dfa4da175147f084c401f1af0d6ac12.png";